module.exports = __webpack_public_path__ + "static/media/goldcoincredit.f550a795.png";